import { render, staticRenderFns } from "./supervisorDelegates.vue?vue&type=template&id=214a23b7&"
import script from "./supervisorDelegates.vue?vue&type=script&lang=js&"
export * from "./supervisorDelegates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports